/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLandlordPartnerRequestDto
 */
export interface CreateLandlordPartnerRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLandlordPartnerRequestDto
     */
    partnerOrgId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLandlordPartnerRequestDto
     */
    partnerName?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLandlordPartnerRequestDto
     */
    uptimeTargetPct?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLandlordPartnerRequestDto
     */
    responseDcDays: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLandlordPartnerRequestDto
     */
    responseAcDays: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLandlordPartnerRequestDto
     */
    penaltyPerDayAmount: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLandlordPartnerRequestDto
     */
    penaltyCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLandlordPartnerRequestDto
     */
    paymentModel: CreateLandlordPartnerRequestDtoPaymentModelEnum;
    /**
     * 
     * @type {Date}
     * @memberof CreateLandlordPartnerRequestDto
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateLandlordPartnerRequestDto
     */
    validTo?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLandlordPartnerRequestDto
     */
    status?: CreateLandlordPartnerRequestDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateLandlordPartnerRequestDto
     */
    notes?: string;
}


/**
 * @export
 */
export const CreateLandlordPartnerRequestDtoPaymentModelEnum = {
    Annual: 'ANNUAL',
    Monthly: 'MONTHLY',
    PerCp: 'PER_CP'
} as const;
export type CreateLandlordPartnerRequestDtoPaymentModelEnum = typeof CreateLandlordPartnerRequestDtoPaymentModelEnum[keyof typeof CreateLandlordPartnerRequestDtoPaymentModelEnum];

/**
 * @export
 */
export const CreateLandlordPartnerRequestDtoStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Expired: 'EXPIRED'
} as const;
export type CreateLandlordPartnerRequestDtoStatusEnum = typeof CreateLandlordPartnerRequestDtoStatusEnum[keyof typeof CreateLandlordPartnerRequestDtoStatusEnum];


/**
 * Check if a given object implements the CreateLandlordPartnerRequestDto interface.
 */
export function instanceOfCreateLandlordPartnerRequestDto(value: object): value is CreateLandlordPartnerRequestDto {
    if (!('responseDcDays' in value) || value['responseDcDays'] === undefined) return false;
    if (!('responseAcDays' in value) || value['responseAcDays'] === undefined) return false;
    if (!('penaltyPerDayAmount' in value) || value['penaltyPerDayAmount'] === undefined) return false;
    if (!('paymentModel' in value) || value['paymentModel'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    return true;
}

export function CreateLandlordPartnerRequestDtoFromJSON(json: any): CreateLandlordPartnerRequestDto {
    return CreateLandlordPartnerRequestDtoFromJSONTyped(json, false);
}

export function CreateLandlordPartnerRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLandlordPartnerRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerOrgId': json['partnerOrgId'] == null ? undefined : json['partnerOrgId'],
        'partnerName': json['partnerName'] == null ? undefined : json['partnerName'],
        'uptimeTargetPct': json['uptimeTargetPct'] == null ? undefined : json['uptimeTargetPct'],
        'responseDcDays': json['responseDcDays'],
        'responseAcDays': json['responseAcDays'],
        'penaltyPerDayAmount': json['penaltyPerDayAmount'],
        'penaltyCurrency': json['penaltyCurrency'] == null ? undefined : json['penaltyCurrency'],
        'paymentModel': json['paymentModel'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
        'status': json['status'] == null ? undefined : json['status'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateLandlordPartnerRequestDtoToJSON(json: any): CreateLandlordPartnerRequestDto {
    return CreateLandlordPartnerRequestDtoToJSONTyped(json, false);
}

export function CreateLandlordPartnerRequestDtoToJSONTyped(value?: CreateLandlordPartnerRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerOrgId': value['partnerOrgId'],
        'partnerName': value['partnerName'],
        'uptimeTargetPct': value['uptimeTargetPct'],
        'responseDcDays': value['responseDcDays'],
        'responseAcDays': value['responseAcDays'],
        'penaltyPerDayAmount': value['penaltyPerDayAmount'],
        'penaltyCurrency': value['penaltyCurrency'],
        'paymentModel': value['paymentModel'],
        'validFrom': value['validFrom'].toISOString(),
        'validTo': value['validTo'] == null ? value['validTo'] : value['validTo'].toISOString(),
        'status': value['status'],
        'notes': value['notes'],
    };
}

